import React, { useState } from 'react';
import './upperbox.css';
import { Link } from 'react-router-dom';

export const Upperbox = () => {
  const [email, setEmail] = useState('info@srikrishnaaindiancuisine.co.uk');

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className='announcement-bar'>
      <div className='announcement-content'>
        <div className='static-info'>
          <p>Call Us +44 7554466904</p>
          <b>|</b>
          <p onClick={handleEmailClick}>{email}</p>
        </div>
        <div className='scrolling-message'>
          <Link to='/Referandearnn' className='scrolling-link'>
            <p>Blue Light Card holders and students get a 10% discount! On Take Away (T&C's apply.)</p>
            <b>/</b>
            <p>Authentic Indian Cuisine for Every Occasion! Enjoy our delicious Take Away service, fast and flavorful, wherever you are!</p>
          </Link>
        </div>
      </div>
    </div>
  );
};
